import { Cluster, Coordinates } from '@remodeling/shop';
import React from 'react';
import { CustomOverlayMap } from 'react-kakao-maps-sdk';
import styled, { css } from 'styled-components';

interface ClusterBoxProps {
  item: Cluster;
  handleClickCluster: (coordinates: Coordinates) => void;
}

const ClusterBox = ({ item, handleClickCluster }: ClusterBoxProps) => {
  return (
    <OverlayContainer onClick={() => handleClickCluster(item)}>
      <CustomOverlayMap
        key={`${item.latitude}-${item.longitude}`}
        position={{
          lat: item.latitude,
          lng: item.longitude,
        }}
      >
        {/* 커스텀 오버레이에 표시할 내용입니다  */}
        <ClusterContainer count={item.count}>{item.count}</ClusterContainer>
      </CustomOverlayMap>
    </OverlayContainer>
  );
};

export default ClusterBox;

const OverlayContainer = styled.div``;

const size = (num: number) => {
  if (num >= 1000) {
    return css`
      width: 120px;
      height: 120px;
    `;
  } else if (num >= 100) {
    return css`
      width: 100px;
      height: 100px;
    `;
  } else if (num >= 10) {
    return css`
      width: 72px;
      height: 72px;
    `;
  } else {
    return css`
      width: 48px;
      height: 48px;
    `;
  }
};

const ClusterContainer = styled.div<{ count: number }>`
  color: ${({ theme }) => theme.colors.natural_color.white};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.accent_color.secondary.blue};
  opacity: 0.6;
  border-radius: 50%;
  ${({ count }) => size(count)}
  ${({ theme }) => theme.typography.button_lg_b};
`;
